import {AfterViewInit, Component, Input, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {FileUploadService} from '../../services/file-upload.service';
import {LoginService} from '../../services/login.service';
import {CmpService } from "../../../create-application/cmp-form/cmp.service";
import {Observable} from 'rxjs/Observable';
import {UploadFileInformation} from '../../data-objects/upload-file-information';
import {FileUpload} from 'primeng/primeng';
import {UploadfilesViewmodel} from '../../viewmodels/uploadfiles-viewmodel';
import {FormControl, Validators} from '@angular/forms';
import {UploadFile3Information} from '../../data-objects/upload-file3-information';

@Component({
  selector: 'app-upload-file3',
  templateUrl: './upload-file3.component.html',
  styleUrls: ['./upload-file3.component.css'],
  
})
export class UploadFile3Component implements OnInit {
  fileListComponent: any[];
  attachmentType: string;
  attachmentTypeList: string[];
  submitErrorMessage: any[];
  validationMessage:string

  @Input()
  uploadfilesViewmodel: UploadfilesViewmodel;
  
  @Input()
  isLand = false;
 
  dropboxUrlControl: FormControl;
  dropboxControlLength = 255;

  constructor(private loginService: LoginService, private fileUploadService: FileUploadService,private cmpService: CmpService) {
     const reg: any = '(http(s)?://)?([\\w-]+\\.)+[\\w-]+[.com]+(/[/?%&=]*)?';
     this.dropboxUrlControl = new FormControl('', [Validators.maxLength(this.dropboxControlLength), Validators.pattern(reg)]);
     this.fileListComponent = [];
     this.submitErrorMessage = [];
     this.attachmentTypeList = [
        "Architectural / Drafting plans (Site plans)",
        "Fire Services & Hydraulic Plans",
        "Engineering / Structural detail",
        "Building Permit",
        "Title Plan",
        "Proposed plan of sub-division",
        "Survey plans",
        "Other"       
      ];
      this.attachmentType = this.attachmentTypeList[0];
  }

  

  ngOnInit() {
    //this.submitErrorMessage = null;
  }

  addFiles(event: any): boolean {
    return this.doAddFiles(event);
  }

  doAddFiles(event): boolean {
    console.log(event.target.files)
    let files= event.target.files
    
    //let regexpNumber = new RegExp('^([a-zA-Z0-9-_\\s])+(.pdf|.PDF|.dwg|.dxf|.dgn)$');
    let regexFileName = new RegExp('^([a-zA-Z0-9-_\\s])+\.(?:(?:[pP][dD][fF]))$');
    //this.uploadfilesViewmodel.files = files; // puts all files into an array
    this.submitErrorMessage = [];
        // if(this.attachmentType ==="Please Select..." || !this.attachmentType ){
        //     this.submitErrorMessage.push("Please Select Plan Type");
        //     return;
        //   }

    if(files) {
      for (let i = 0; i < files.length; i++) {  
        if(!regexFileName.test(files[i].name)){
          this.submitErrorMessage.push(`${files[i].name} : Files must be in PDF format and names can only contain alpha-numeric characters, spaces and underscores.`);
           continue;
         }

        // if(!regexpNumber.test(files[i].name.toLowerCase())){
         
        //  this.submitErrorMessage.push(`<strong>[ERROR]</strong> ${files[i].name}<br/><strong>File name can contain only alpha-numeric characters, spaces, underscores and dashes.</strong>`);
        //   continue;
        // }

        if(files[i].name.length > 100){
          //this.uploadfilesViewmodel.files.splice(i, 1);
          //this.submitErrorMessage = `File Name: ${this.uploadfilesViewmodel.files[i].name}<br/>File name can contain only alpha-numeric characters, spaces, underscores and dashes.`;
          //return false;
          this.submitErrorMessage.push(`${files[i].name} : The length of file name must be less than 100 characters.`);
          continue;
        }
      
        const fileSize: number = Number(((files[i].size / 1024) / 1024).toFixed(4)); // MB
        if (files[i].name !== 'item' && typeof files[i].name !== 'undefined' && fileSize > 20) {
          //this.uploadfilesViewmodel.files.splice(i, 1);
          //this.submitErrorMessage = 'Please limit individual files size to 20MB and ensure files are in a PDF format.';
          this.submitErrorMessage.push(`${files[i].name} : Please limit individual files size to 20MB.`);
          //return false;
          continue;
        }   
        
        if(this.fileListComponent.find(x=> x.file.name === files[i].name && x.file.size === files[i].size))
        {
          this.submitErrorMessage.push(`${files[i].name} : File already exists in the list.`);
          continue; 
        }
       /* if (!this.fileListComponent.find((x) => x.attachmentType === "Architectural/Drafting plans")
        ) {
          this.submitErrorMessage.push("Please Upload Site Plan");
  
          return false;
        }*/

        if (files.length > 0) {
            this.submitErrorMessage = [];
            this.uploadfilesViewmodel.files = files;
            this.uploadfilesViewmodel.files.attachmentType =this.attachmentType;
            this.fileListComponent.push({
                attachmentType: this.attachmentType,
                file: files.item(0)
              });
        
        }      
        this.cmpService.addFile(this.fileListComponent);
        event.target.value=""
        return (this.uploadfilesViewmodel.files.length > 0);
      }
    }
  }

  isInvalid(){
    this.submitErrorMessage = [];
    if(this.attachmentType ==="Please Select..." ){
      return false
    }
    if (!this.uploadfilesViewmodel.files && this.attachmentType) {
      this.submitErrorMessage.push("Please upload at least one file.");
      return true;
    }
    if (!this.fileListComponent.find((x) => x.attachmentType === this.attachmentTypeList[0])) {
      this.submitErrorMessage.push("Please upload at least one site plan (Architectural / Drafting plans)");
      return true;
    }
  }
  

  uploadFiles(): Observable<string[]> {
    return this.cmpService.uploadFile(this.loginService.getToken());
  }

  updateFileInformation(uploadFileInfo: UploadFile3Information): Observable<boolean> {
    return this.cmpService.updateFileInformation(uploadFileInfo, this.loginService.getToken());
  }

  get isDropbox(): boolean {
    return this.uploadfilesViewmodel.isDropbox;
  }

  get dropboxUrl(): string {
    return this.uploadfilesViewmodel.dropboxUrl;
  }

  set dropboxUrl(v: string) {
    this.uploadfilesViewmodel.dropboxUrl = v;
  }

  get isValid(): boolean {  
    this.submitErrorMessage = null;
    
   /* if (!this.isDropbox && !this.fileUploadService.isValid()) {    
      this.submitErrorMessage = 'Please upload file.';
      return false;   
    } else if (this.isDropbox && this.uploadfilesViewmodel.dropboxUrl === '' && this.uploadfilesViewmodel.dropboxUrl.length === 0) {
      this.submitErrorMessage = 'Please enter drop box url.';
      return false;
    } else if (this.isDropbox && this.dropboxUrlControl.invalid) {
      this.submitErrorMessage = 'Please enter valid drop box url.';
      return false;
    }*/

    return true;
  }

  /*set isDropboxValue(v: string) {
    this.uploadfilesViewmodel.isDropboxValue = v;
    switch (v) {
      case 'file':
        this.uploadfilesViewmodel.isDropbox = false;
        this.dropboxUrlControl.disable();
        this.uploadControl.enable();
        break;
      case 'dropbox':
        this.uploadfilesViewmodel.isDropbox = true;
        this.dropboxUrlControl.enable();
        this.uploadControl.disable();
        break;
    }
  }*/

  get isDropboxValue(): string {
    return this.uploadfilesViewmodel.isDropboxValue;
  }

  set selectedValue(v: string) {
    this.attachmentType = v;
  }

  get selectedValue(): string {
    return this.attachmentType;
  }

  removeItem(v) {
    if (this.fileListComponent) {
      let index = this.fileListComponent.indexOf(v);
      this.fileListComponent = this.fileListComponent.filter((val, i) => i != index);
      this.cmpService.fileList= this.fileListComponent;
      this.submitErrorMessage = [];
    }
  }

}

@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  transform(bytes: number): string {
    if (isNaN(bytes) || bytes === 0) return '0 Bytes';

    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/upload-file3/upload-file3.component.ts